import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  GetZoomLink,
  ScheduleCall,
  ZoomStatusUpdate,
} from "../../../../components/Header/Data2";
import CustomerAvaliableCalander from "../../../../components/Header/CustomerAvaliableCalander";
import {
  addIncomingMessage,
  setOppertunity,
  setOppertunityStage,
  setSelectedConversation,
  updateSelectedConvoFields,
} from "../../../../redux/slices/MsgSlice";
import { sendMessage } from "../../../../components/Header/Data";
import { useSocket } from "../../../../contexts/SocketContext";
import {
  Dialog,
  DialogContent,
  Button,
  TextField,
  Typography,
  Box,
  IconButton,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const ScheduleCallModal = ({ isOpen, closeModal, msg }) => {
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const [reserveDate, setReserveDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [loading, setLoading] = useState(false);
  const providerZone = msg?.providerTimezone;
  const custZone = msg?.customerTimezone;
  const logUser = user?.Role;
  const dispatch = useDispatch();
  const { sendNewMessage } = useSocket();
  const { selectedConvo } = useSelector((state) => state.messages);

  const handleSend = async (zoomLink) => {
    if (zoomLink.trim()) {
      const messageForm = {
        customerId:
          selectedConvo?.customerId === user.UserID
            ? selectedConvo?.createdBy
            : selectedConvo?.customerId,
        postId: selectedConvo?.postId,
        postType: 1, // message 1 or requestQuote 2 or offer my service 3
        parentId:
          selectedConvo?.parentId === 0
            ? selectedConvo?.Id
            : selectedConvo?.parentId,
        Description: `Call Scheduled for ${reserveDate} at ${startTime} for 30 mins with ${zoomLink} `,
        messageStatus: 3,
        customerTimezone: custZone,
        providerTimezone: providerZone,
        createdBy: user.UserID,
        roleId: user.RoleId,
        ownerId: selectedConvo?.ownerId,
        userName: user.UserName.split("@")[0].trim(),
        Email: user.Email,
        serviceNeed: "need",
        needName: selectedConvo?.postName,
      };
      const response = await sendMessage(messageForm);
      if (response.Data) {
        let data = response.Data;
        if (data.parentId == 0) {
          dispatch(setSelectedConversation(data));
        }
        sendNewMessage(response.Data);
        dispatch(addIncomingMessage(response.Data));
        toast.success("Message Sent");
      }
    }
    closeModal();
  };

  const AcceptZoomCall = async () => {
    setLoading(true);
    const formattedStartTime = selectedConvo?.startTime;
    const formData = {
      startTime: formattedStartTime,
      customerName: msg?.userName.split("@")[0].trim(),
      vendorName: msg?.senderName,
      needName: msg?.postName,
    };
    try {
      const linkResponse = await GetZoomLink(formData, msg.Id);
      if (linkResponse && linkResponse.id && linkResponse.join_url) {
        const updateFormData = {
          updatedBy: user.UserID,
          zoomStatus: 3,
          meetingId: linkResponse.id,
          meetingLink: linkResponse.join_url,
          meetingStartLink: linkResponse.start_url,
          customerTimezone: custZone,
          providerTimezone: providerZone,
          reserveDate: reserveDate,
          startTime: startTime,
          needName: msg?.postName,
        };
        await ZoomStatusUpdate(updateFormData, msg.Id);
        dispatch(
          updateSelectedConvoFields({
            zoomStatus: 3,
            reserveDate: updateFormData.reserveDate,
            startTime: updateFormData.startTime,
            meetingId: linkResponse.id,
            meetingLink: linkResponse.join_url,
            meetingStartLink: linkResponse.start_url,
          })
        );
        
        await handleSend(linkResponse.join_url);
      } else {
        toast.error("Error: Invalid response format or join_url not found");
      }
    } catch (error) {
      console.error("Error accepting Zoom call:", error);
      toast.error("An error occurred while accepting the Zoom call");
    }
    setLoading(false);
  };

  const handleCallwithoutLogin = async () => {
    if (msg?.createdBy === user?.UserID && logUser === "provider") {
      await AcceptZoomCall();
    } else {
      await ScheduleNewCall();
    }
  };

  const ScheduleNewCall = async () => {
    setLoading(true);
    const currentDate = new Date().toISOString().split("T")[0];
    const currentTime = new Date();
    if (!reserveDate) {
      toast.error("Please enter date");
      return;
    }
    if (!startTime) {
      toast.error("Please enter time");
      return;
    }
    if (reserveDate < currentDate) {
      toast.error("Please do not enter a previous date");
      return;
    }

    const selectedDateTime = new Date(`${reserveDate}T${startTime}`);
    if (selectedDateTime < currentTime) {
      toast.error("Please do not enter a completed time");
      return;
    }
    const request = {
      reserveDate: reserveDate,
      startTime: startTime,
      customerTimezone: custZone,
      providerTimezone: providerZone,
      zoomStatus:
        msg?.createdBy === user?.UserID && logUser === "provider" ? 3 : 1,
      zoomRole: user.UserID,
    };
    let id = msg.Id;
    await ScheduleCall(id, request);
    if (msg?.createdBy === user?.UserID && logUser === "provider") {
      await AcceptZoomCall();
    }
    setStartTime("");
    setReserveDate("");
    setLoading(false);
    closeModal();
    dispatch(setOppertunity(6));
    dispatch(setOppertunityStage(true));
  };

  let parsedAvailability = [];
  if (msg && typeof msg?.availableFrom === "string") {
    try {
      parsedAvailability = JSON.parse(msg?.availableFrom);
    } catch (error) {
      console.error("Error parsing msg.availableFrom:", error);
      parsedAvailability = [];
    }
  }

  const convertTo12Hour = (time) => {
    if (typeof time !== "string") {
      return "";
    }
    const [hours, minutes] = time.split(":");
    const suffix = hours >= 12 ? "PM" : "AM";
    const adjustedHours = hours % 12 || 12;
    return `${adjustedHours}:${minutes} ${suffix}`;
  };

  return (
    <Dialog
      open={isOpen}
      onClose={closeModal}
      maxWidth="md"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "5px",
          padding: "10px",
          maxHeight: "80vh",
          overflowY: "auto",
          margin: "auto",
          border: "1px solid gray",
        },
        "& .MuiDialog-container": {
          backgroundColor: "rgba(0, 0, 0, 0.5)", // Black mask effect
        },
      }}
    >
      <DialogContent className="p-2">
        <Box className="d-flex justify-content-end">
          <IconButton onClick={closeModal}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Box className="mt-4">
          <Typography
            className="text-sm fw-bold"
            // color={theme.palette.primary.main}
            variant="p"
            fontWeight={"bold"}
          >
            Please schedule the call using the tool below within the Other Party
            mentioned availability schedule.
          </Typography>
          <Typography className="py-2">
            <strong>Note:</strong> All the scheduled calls are set to the
            default PST timezone. If necessary, please go to the Profile section
            to change the timezone
          </Typography>
          {msg?.ownerId === user.UserID ? (
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography className="mb-2">
                  Date <span className="text-red-500 font-bold">*</span>
                </Typography>
                <TextField
                  type="date"
                  fullWidth
                  onChange={(e) => setReserveDate(e.target.value)}
                  InputProps={{
                    inputProps: {
                      min: new Date().toISOString().split("T")[0],
                    },
                  }}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography className="mb-2">
                  From <span className="text-red-500 font-bold">*</span>
                </Typography>
                <TextField
                  type="time"
                  fullWidth
                  onChange={(e) => setStartTime(e.target.value)}
                />
              </Grid>
            </Grid>
          ) : (
            <CustomerAvaliableCalander
              reserveDate={reserveDate}
              startTime={startTime}
              setReserveDate={setReserveDate}
              setStartTime={setStartTime}
              availableDays={parsedAvailability}
              ownerId={msg?.customerId}
            />
          )}
          {startTime && (
            <Typography className="mt-2 text-sm">
              The Calls will be scheduled for 30 min starting from{" "}
              {convertTo12Hour(startTime)}
            </Typography>
          )}
        </Box>
        <Box className="flex justify-end mt-4">
          <Button
            variant="outlined"
            color="primary"
            onClick={handleCallwithoutLogin}
            disabled={loading}
          >
            Schedule
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default ScheduleCallModal;
